export class BaseError extends Error {
    constructor(message, cause) {
        super(message);
        this.cause = cause;
        this.name = this.constructor.name;
    }
    toString() {
        return `${this.getType(this)}${this.message}${this.getCauseString()}`;
    }
    getType(error) {
        return `[${error.name || 'raw error'}] `;
    }
    getCauseString() {
        if (!this.cause) {
            return '';
        }
        return `\nCause: ${this.cause instanceof BaseError ? this.cause.toString() : this.getTypedCauseMessage(this.cause)}`;
    }
    getTypedCauseMessage(error) {
        return `${this.getType(error)}${error.message || error}`;
    }
}
// TODO: check result outside of jasmine (jasmine treats errors his own way)
// TODO: wrap platform exceptions (code+message) in particular error class ?
// TODO: use Error.prepareStackTrace(error, structuredStackTrace) ?
// TODO: use lib like https://github.com/defunctzombie/node-superstack or https://github.com/ddsol/superStack ?
export class IllegalStateError extends BaseError {
    constructor(message, cause) {
        super(message);
        this.cause = cause;
    }
}
//# sourceMappingURL=error.js.map